import { ViewChild, Component, OnInit } from '@angular/core';
import { expiryTypes, PmaDocumentCentreCategory } from '@feature/pma-document-centre/pma-document-centre-types';
import { empty, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs';
import { PmaDocumentCentreCategoryEditorFacadeService } from
  '@feature/pma-document-centre/services/pma-document-centre-category-editor-facade.service';
import { PmaDocumentCentreCategoryDialogComponent } from
  '@feature/pma-document-centre/components/pma-document-centre-category-dialog/pma-document-centre-category-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'mojo-pma-document-centre-category-editor',
  templateUrl: './pma-document-centre-category-editor.component.html',
})
export class PmaDocumentCentreCategoryEditorComponent implements OnInit {

  categories: Observable<PmaDocumentCentreCategory[]>;
  selectedCategory: PmaDocumentCentreCategory;
  defaultExpiryTypes = expiryTypes;

  @ViewChild(PmaDocumentCentreCategoryDialogComponent) categoryEditor: PmaDocumentCentreCategoryDialogComponent;

  constructor(
    private confirmationService: ConfirmationService,
    private messageService: ToastrService,
    private readonly facade: PmaDocumentCentreCategoryEditorFacadeService) {
    this.categories = facade.categories();
    facade.loadCategories();
  }

  showAddDialog() {
    this.categoryEditor.showAddDialog();
  }

  getExpiryLabel(category: PmaDocumentCentreCategory) {
    return category.expiryType ? `${category.expiryType.fromMins(category.durationMins)} ${category.expiryType.label}` : '';
  }

  showEditDialog() {
    this.categoryEditor.showEditDialog(this.selectedCategory);
  }

  confirmDelete() {
    this.confirmationService.confirm({
      message: `Are you sure that you want to remove this category?`,
      header: 'Confirmation',
      accept: () => this.facade.deleteCategory(this.selectedCategory).pipe(
        tap(() => this.messageService.success(`Category '${this.selectedCategory.name}' deleted.`)),
        catchError(() => {
          this.messageService.error(`Could not delete category.`);
          return empty();
        })).subscribe()
    });
  }

  handleOnSave(category: PmaDocumentCentreCategory) {
    this.facade.saveCategory(category).pipe(
      tap(() => {
        this.selectedCategory = category;
        this.messageService.success(`Category '${category.name}' saved sucessfully.`);
      }),
      catchError(() => {
        this.messageService.error(`Could not save category.`);
        return empty();
      })
    ).subscribe();
  }

  isNoneSelected() {
    return this.selectedCategory == null;
  }

  ngOnInit() {
  }

}
